<div class="section" *ngIf="hasContent || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Aircraft and Equipment Rentals</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="planeAndGliderTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Planes:
          <mat-icon (click)="openEditRentalsDialog(['Rental::Airplane::','Rental::Glide'], null , 'Planes')" *ngIf="editModeSet && !isRegionalManager"
                    class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="planeAndGliderTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !planeAndGliderTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="equipmentTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Equipment:
          <mat-icon (click)="openEditRentalsDialog(['Rental::Equipment::'], null , 'Equipment')" *ngIf="editModeSet && !isRegionalManager"
                    class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="equipmentTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !equipmentTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="rotorcraftTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Rotorcraft:
          <mat-icon (click)="openEditRentalsDialog(['Rental::Rotorcraft::'], null , 'Rotorcraft')" *ngIf="editModeSet && !isRegionalManager"
                    class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="rotorcraftTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !rotorcraftTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="simulatorTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Simulator:
          <mat-icon (click)="openEditRentalsDialog(['Rental::Simulator::'], null , 'Simulator')" *ngIf="editModeSet && !isRegionalManager"
                    class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="simulatorTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !simulatorTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="editModeSet && !isRegionalManager; else notEditing" class="section__footer">
    <mat-checkbox #checkbox [checked]="isChecked(privateTag.tagId)" [id]="privateTag.tagId"
      (change)="checkBoxChanged($event)" class="rentals__disclaimers">Rentals not available to the general public.</mat-checkbox>
  </div>
</div>
<ng-template #notEditing>
  <div class="section__footer" *ngIf="hasTag(business.tags, 'Rental::Private')">
    <div class="rentals__disclaimers">
      <em>Rentals not available to the general public.</em>
    </div>
  </div>
</ng-template>
